import { Container } from "@mui/material";

const ClientInteractions = () => {
  return (
    <Container sx={{ height: "calc(100vh - 200px)", width: "100%", maxWidth: "none !important" }}>
      <iframe
        title="Client Interactions"
        width="100%"
        height="100%"
        src="https://app.powerbi.com/reportEmbed?reportId=8c7231b0-4d83-4fbe-8a1a-eccea396e945&autoAuth=true&ctid=bbfeea83-3c0f-4fcc-838e-a0848f3fcb93"
        frameBorder={0}
        allowFullScreen
      ></iframe>
    </Container>
  );
};

export default ClientInteractions;
